import AbstractInstaller from "../../core/application/AbstractInstaller";
import ScenarioPlayerEvent from "../scenario/ScenarioPlayerEvent";
import ChatModel from "./model/ChatModel";
import PlayChatCommand from "./controller/PlayChatCommand";
import ChatContactItemFactory from "./controller/ChatContactItemFactory";
import ChatMessageFactory from "./controller/ChatMessageFactory";

export default class ChatInstaller extends AbstractInstaller {
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        injector.mapClass("chatModel", ChatModel, true);
        injector.mapClass("chatContactItemFactory", ChatContactItemFactory, true);
        injector.mapClass("chatMessageFactory", ChatMessageFactory, true);

        commands.add(ScenarioPlayerEvent.CHAT_DIALOG_AVAILABLE, PlayChatCommand);

        // Skin mappings can be found in the SmartphoneInstaller (or other visual shells/ applications that use the chat)
    }
}